import React, { useState } from 'react';
import { Stack } from '@mui/material';
import DownloadIcon from '@/public/icons/files/download.svg';
import PrintIcon from '@/public/icons/files/print.svg';
import CloseIcon from '@/public/icons/files/close.svg';
import BoxButton from '@/components/FileViewer/@components/BoxButton';
import AIStarIcon from '@/public/icons/ai-stars.svg';
import Spinner from '@/components/@IntranetLibrary/Spinner';
import { downloadFile } from '@/utils';

export interface FileViewerActionsProps {
  fileName: string;
  fileUrl: string;
  fileUuid: string;
  isAiPanelOpen: boolean;
  onToggleAiPanel: () => void;
  isMobile: boolean;
  onClose: () => void;
  disableAiPanel?: boolean;
}

const FileViewerActions: React.FC<FileViewerActionsProps> = ({
  fileName,
  fileUrl,
  fileUuid,
  isAiPanelOpen,
  onToggleAiPanel,
  isMobile,
  onClose,
  disableAiPanel = false,
}) => {
  const iconSize = 28;
  const [isDownloading, setIsDownloading] = useState(false);

  const handlePrint = () => {
    window.print();
  };

  const handleDownload = async () => {
    if (isDownloading) return;

    // React Native WebView 환경 처리
    if (
      (window.isRNWebview || window.isRNWebview2) &&
      window.ReactNativeWebView
    ) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          actionType: 'OPEN_BROWSER',
          url: fileUrl,
        }),
      );
      return;
    }

    setIsDownloading(true);
    try {
      await downloadFile({
        name: fileName,
        link: fileUrl,
        uuid: fileUuid,
      });
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <Stack gap={isMobile ? '12px' : '24px'} flexDirection={'row'}>
      {/* 인쇄 버튼 */}
      {!isMobile && (
        <BoxButton
          icon={<PrintIcon />}
          iconSize={iconSize}
          onClick={handlePrint}
          title="인쇄"
        />
      )}

      {/* 다운로드 버튼 - RN 앱에서 다운로드 미지원 상태이므로 모바일에서는 임시로 숨김 처리 */}
      {!isMobile && (
        <BoxButton
          icon={isDownloading ? <Spinner theme="white" /> : <DownloadIcon />}
          iconSize={iconSize}
          onClick={handleDownload}
          disabled={isDownloading}
          title="다운로드"
        />
      )}

      {/* AI 토글 버튼 */}
      {!disableAiPanel && (
        <BoxButton
          icon={<AIStarIcon />}
          selected={isAiPanelOpen}
          tone="ai"
          iconSize={iconSize}
          onClick={onToggleAiPanel}
          title="AI Chat"
        />
      )}

      {isMobile && (
        <BoxButton
          icon={<CloseIcon />}
          iconSize={iconSize}
          onClick={onClose}
          title="닫기"
        />
      )}
    </Stack>
  );
};

export default FileViewerActions;
